import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateMeetingInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateMeetingMutation = graphql(`
  mutation CreateMeeting($input: CreateMeetingInput!) {
    createMeeting(input: $input) {
      id
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      series {
        id
        __typename
        cadence
        startDate
        until
        scheduledStartTime
        scheduledEndTime
      }
      __typename
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useCreateMeeting() {
  const [result, createMeetingMutation] = useMutation(CreateMeetingMutation);
  const [error, setError] = useState<Error | null>(null);

  const createMeeting = useCallback(
    async (input: CreateMeetingInput) => {
      try {
        const response = await createMeetingMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.createMeeting;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createMeetingMutation],
  );

  return { createMeeting, result, error };
}
